import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

export default function FAQItem({ title, children, icon }: Props) {
  return (
    <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-indigo-200 hover:shadow-xl">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-lg text-indigo-600">
          {icon}
        </div>
        <div className="min-w-0">
          <h2 className="text-base font-semibold leading-7 tracking-tight text-slate-950">{title}</h2>
          <p className="mt-3 text-sm leading-7 text-slate-600">{children}</p>
        </div>
      </div>
      <div className="mt-6 h-px w-full bg-gradient-to-r from-indigo-200 to-transparent" />
    </article>
  );
}
